<template>
  <div class="form">
    <slot />
    <div v-if="type == 'login' && active == 1 && screenWidth>600">
      <p
        v-if="number != 1312"
        v-show="error"
        :class="{info_err: true}"
        :style="errorLeft"
      >
        {{ error }}
      </p>
      <div v-if="isPc">
        <van-dialog
          v-model="showDialog"
          :confirm-button-text="lang.continueLang"
          confirm-button-color="#e50113"
        >
          <div class="message">
            <p v-html="error" />
          </div>
        </van-dialog>
      </div>
    </div>
    <div v-if="type == 'login' && active == 2 && screenWidth>600">
      <p
        v-if="number != 1312"
        v-show="error"
        :class="{info_err: true, btm0: screenWidth>=750}"
        :style="errorLeft"
      >
        {{ error }}
      </p>
      <div v-if="isPc">
        <van-dialog
          v-model="showDialog"
          :confirm-button-text="lang.continueLang"
          confirm-button-color="#e50113"
        >
          <div class="message">
            <p v-html="error" />
          </div>
        </van-dialog>
      </div>
    </div>
    <div
      v-if="type == 'login' && active == 1 && screenWidth<=600"
      class="form_err"
    >
      <p
        v-show="error"
        :class="{info_err: true, info_err_medium: screenWidth>600 && screenWidth<750}"
        :style="errorLeft"
        v-html="error"
      />
    </div>
    <div
      v-if="type == 'login' && active == 2 && screenWidth<=600"
      class="form_err"
    >
      <p
        v-show="error"
        :class="{info_err: true, info_err_medium: screenWidth>600 && screenWidth<750}"
        :style="errorLeft"
        v-html="error"
      />
    </div>
    <div v-if="type == 'forget' && active == 1 && screenWidth<600">
      <p
        v-show="error"
        :class="{info_err: true, btm25: true}"
        :style="errorLeft"
      >
        {{ error }}
      </p>
    </div>
    <div v-if="type == 'forget' && active == 2 && screenWidth<600">
      <p
        v-show="error"
        :class="{info_err: true, info_err_medium: screenWidth>600 && screenWidth<750}"
        :style="errorLeft"
      >
        {{ error }}
      </p>
    </div>
    <div v-if="type == 'forget' && active == 1 && screenWidth>=600">
      <p
        v-show="error"
        :class="{info_err: true, info_err_medium: screenWidth>600 && screenWidth<750}"
        :style="errorLeft"
      >
        {{ error }}
      </p>
    </div>
    <div v-if="type == 'forget' && active == 2 && screenWidth>=600">
      <p
        v-show="error"
        :class="{info_err: true, btm50: true, info_err_medium: screenWidth>600 && screenWidth<750}"
        :style="errorLeft"
      >
        {{ error }}
      </p>
    </div>
    <div v-if="type == 'reset'">
      <p
        v-show="error"
        :class="{info_err: true, btm26: true, info_err_medium: screenWidth>600 && screenWidth<750}"
        :style="errorLeft"
      >
        {{ error }}
      </p>
    </div>
    <!-- <div>
      <p :class="{info_err: true, btm50: screenWidth>=750 && active !== 1}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div>
      <p :class="{info_err: true, btm50: screenWidth>=750 && active !== 1}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div>
      <p :class="{info_err: true, btm50: screenWidth>=750 && active !== 1}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div> -->
  </div>
</template>

<script>
import { Dialog } from 'vant';
import lang from '../../../common/language/new_login.js';

export default {
  props: {
    error: {
      default: ''
    },
    errorLeft: {
      default: ''
    },
    active: {
      default: null
    },
    type: {
      default: 'login'
    },
    isPc: {
      default: false,
    },
    number: {
      default: null,
    },
    
  },
  data() {
    return {
      lang: lang,
      screenWidth: false,
      showDialog: false,
    };
  },
  mounted() {
    // this.showDialog = this.error ? true : false;
    // console.log(this.active, this.type);
    // console.log(this.isPc, this.isPc);
    this.screenWidth = document.body.clientWidth
    
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {
    show() {
      this.showDialog = false;
    },
    openDialog() {
      this.showDialog = true; // 打开弹窗
    }
  }
};
</script>
<style lang="scss" scoped>
@import url('../../assets/base.css');
.van-dialog{
  width: 406px;
  min-height: 180px;
  padding: 20px;
  border-radius: 0;
  .van-dialog__content {
    .message {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #ED1C24;
      letter-spacing: 0;
      line-height: 22px;
      text-align: left;
      margin-bottom: 30px;
    }
  }
  /deep/ .van-hairline--top {
    .van-button {
      width: 140px;
      height: 40px;
      line-height: 40px;
      background: #ED1C24;
      border-radius: 4px;
      .van-button__text {
        color: #ffffff;
      }
    }
  }
  /deep/ .van-hairline--top::after {
    border-top-width: 0px;
  }
}
.form {
  position: relative;
  .form_err {
    height: 5px;
    .info_err {
      margin-top: 15px;
    }
  }
  .info_err {
    line-height: 17px;
    color: #ED1C24;
    position: absolute;
    margin-top: 5px;
    // bottom: -25px;
    // bottom: -50px;
  }
  .info_err_medium {
    @media (min-width: 600px) and (max-width: 750px) {
      line-height: 17px;
      color: #ED1C24;
      position: absolute;
    }
  }
  .message_box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    
  }
}
.btm50 {
  bottom: -50%;
}
.btm0 {
  bottom: 0!important;
}
.btm20 {
  bottom: -20%;
}
.btm25 {
  bottom: -25%;
}
</style>
